<template>
    <div class="app-root min-h-screen w-full">
        <Toast position="top-right"/>
        <AppConfirmDialog />
        <RoleMismatchScreen v-if="authStore.hasRoleMismatch" />
        <RouterView v-else />
    </div>
    <noscript v-if="vue_mode == 'production'"><img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=2925514441162312&ev=PageView&noscript=1" /></noscript>
</template>

<script setup>
import { onMounted } from 'vue'
import AppConfirmDialog from '@/components/shared/app_confirm_dialog.vue'
import Toast from 'primevue/toast'
import { useAuthStore } from '@/stores/auth'
import RoleMismatchScreen from '@/views/shared/role_mismatch_screen.vue'
import { bootstrapFacebookPixel } from '@/shared/lib/landingAnalytics'

const authStore = useAuthStore()
const vue_mode = process.env.VUE_APP_MODE || 'development'
const fbPixelId = process.env.VUE_APP_FB_PIXEL_ID || null

onMounted(() => {
    bootstrapFacebookPixel(fbPixelId)
})
</script>
